import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import Button from '../../components/Button';
import EventDialog from '../../components/EventDialog'
import { connect } from 'react-redux';
import { selectIssue, saveIssueTitle, saveIssueKey, saveOpinion } from '../../actions';

const mapStateToProps = (state) => {
    const { setMediaFilter, selectIssue, saveAPIToken, saveIssueKey } = state;
    return {
        isMobile: "MOBILE" === setMediaFilter,
        issue: selectIssue,
        token: saveAPIToken,
        issueKey: saveIssueKey
    }
  }

const mapDispatchToProps = dispatch => {
    return {
        opinion: opinion => dispatch(saveOpinion(opinion)),
        select: (issue) => dispatch(selectIssue(issue)),
        saveIssueTitle: (issue) => dispatch(saveIssueTitle(issue)),
        saveIssueKey: (key) => dispatch(saveIssueKey(key)),
    }
}

class IssueScreen extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            issues: [] // {title, description, _id}
        }

        this.onNextClickHandler = this.onNextClickHandler.bind(this)
    }

    componentDidMount() {
        const { select, saveIssueTitle, saveIssueKey, token } = this.props;

        fetch(`${process.env.REACT_APP_URL}/dev/issues`, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then((res) => res.json())
            .then((response) => 
                this.setState({issues: response})    
            )

        select('');
        saveIssueTitle('');
        saveIssueKey('');
    }

    dispatchIssue(issue) {
        this.props.select(issue);
    }
    
    onClickHandler(selectedIssue, bl) {
        const { select, saveIssueTitle, saveIssueKey } = this.props;
        if (bl) {
            select(selectedIssue._id);
            saveIssueTitle(selectedIssue.title);
            saveIssueKey(selectedIssue.key);
        }
        else{
            select('');
            saveIssueTitle('');
            saveIssueKey('');
        }
    }

    onNextClickHandler () {
        const {issue, issueKey, opinion} = this.props;
        if (issue) {
            opinion('')
            this.props.history.push(`/result/${issueKey}`)
        }
    }

    render() {
        const { issues } = this.state;
        const { issue, isMobile } = this.props;
        return (
            <div className="wrapper">
                <Header />
                <EventDialog></EventDialog>
                <div className="container">
                    <div className="title text-light text-center issue-title">
                        다른 이슈 보기
                    </div>
                    {
                        issues.map((item, i) => {
                            return (<Button key={item._id} id={item._id} type={`button-transparent select button ${item.numOpinions >= 200 ? 'hot' : ''} ${item.prevOpinion ? 'done' : ''}`} content={isMobile ? item.shortTitle : item.title} onClick={(bl) => this.onClickHandler(item, bl)}/>)
                        })
                    }
                    <div className="next">
                        <Button type={`select button text-bold ${issue ? 'button-gradient' : 'disabled'}`} disabled={issue ? false : true} content="다음" onClick={this.onNextClickHandler}/>
                    </div>
                </div>
            </div>
        )
    }
}

IssueScreen.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    issue: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueScreen);